<template>
	<div style="flex: 1;padding: 20px;display: flex;flex-direction: column;color:#fff;font-size: 14px;">
		<div style="flex:1;background-color: rgb(75, 83, 87);display: flex;flex-direction: column;">
			<div style="padding: 15px;border-bottom: 1px solid #3f4649;display: flex;align-items: center;justify-content: space-between;">
				消息列表
				<div style="display: flex;align-items: center;">
					<span style="margin-right: 10px;">共{{total}}条数据</span>
					<el-button icon="el-icon-refresh" type="primary" size="small" style="border-radius: 0;" @click="getData">刷新数据</el-button>
				</div>
			</div>
			<div style="padding: 20px 20px 0px 20px;">
				<el-table :data="list" stripe
					style="width: 100%;flex: 1;padding:0px 0px;background-color: rgb(75, 83, 87);color: #fff;" size="small"
					:header-cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}"
					:cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}" :row-style="{border_color:'rgb(75, 83, 87)'}"
					height="600" v-loading="loading">
					<el-table-column label="目标账号"  align="left" width="300">
						<template slot-scope="scope">
							{{scope.row.to_account}}
						</template>
					</el-table-column>
					<el-table-column label="消息内容"  align="center">
						<template slot-scope="scope">
							{{scope.row.content}}
						</template>
					</el-table-column>
					<el-table-column label="发送时间" width="300" align="center">
						<template slot-scope="scope">
							{{scope.row.datetime}}
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="footer" style="margin-top: 15px;">
				<el-pagination layout="total, prev, pager, next" @current-change="toPage" :total="total"
					:page-sizes="[10,50,100,500,1000]" :current-page="form.page" :page-size="limit">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		data() {
			return {
				cards: '',
				loading: false,
				days: 0,
				limit: 15,
				total: 0,
				form: {
					page:1,
				},
				software_list: [],
				now_timestamp: 0,
				list: [],
			}
		},
		created() {
			this.getData()
		},
		computed: {
			...mapState({
				user: state => state.user,
				reload:state=>state.reload
			})
		},
		watch:{
			reload(n,v){
				this.getData()
			}
		},
		methods: {
			
			confromCard() {
				this.dialogOptions = true
			},
			toEdit(agent_software_id) {
				this.$emit('toEdit', agent_software_id)

			},
			
			toDelete(item) {
				this.$confirm('删除后，该代理及子代理都会失去您软件的代理权限，确认删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$H.post('/verify_center/v1_0_1.Agent/Delete', {
						id:item.id
					}).then(res => {
						if(!res.data) return;
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.search()
					});

				}).catch(() => {

				});
			},
			
			search() {
				this.form.page = 1
				this.getData()
			},
			getData() {
				this.loading = true
				this.$H.post('/wechat_msg/v1_0_1.Msg/List', this.form).then(res => {
					this.loading = false
					if (res.data) {
						if (this.form.page === 1) {
							this.total = res.data.list.total
						}
						this.list = res.data.list.data
					}
				}).catch(err => {
					this.loading = false
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			toPage(val) {
				this.form.page = val
				this.getData()
			}
		}
	}
</script>

<style>
	.search input {
		background-color: rgb(75, 83, 87);
		color: #fff;
		border-radius: 0px;

	}

	.el-dialog__header {
		background-color: #409EFF;
		color: #fff;
	}

	.el-dialog__header .el-dialog__title {
		color: #fff;
	}

	.el-dialog__close el-icon el-icon-close {
		color: #fff;
	}

	.footer {
		margin-top: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px 0;
	}

	.footer .el-pagination__total {
		color: #fff !important;
	}

	.footer input {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
		border-radius: 0;
	}

	.footer>>>.btn-prev {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
	}

	.el-table td.el-table__cell,
	.el-table th.el-table__cell.is-leaf {
		border-bottom: 1px solid #909399 !important;
	}
</style>